import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Radio, Space, Form } from 'antd';

import FormItem from '@/components/ui/FormItem';
import { ADDITIONAL_FACTOR_GROUPS } from '@/components/views/Report/KimLhc/Constants';
import * as S from './styles';

interface AdditionalFactorsFormItemProps {
	fieldNamePrefix?: string | string[];
	required?: boolean;
}

const buildFieldName = (prefix: string | string[] | undefined, fieldName: string): string[] => {
	if (!prefix) {
		return [fieldName];
	}

	if (Array.isArray(prefix)) {
		return [...prefix, fieldName];
	}

	return [prefix, fieldName];
};

export function AdditionalFactorsFormItem({
	required = false,
	fieldNamePrefix
}: Readonly<AdditionalFactorsFormItemProps>): JSX.Element {
	const form = Form.useFormInstance();

	const handleRadioClick = (fieldName: string, selectedValue: string | undefined) => {
		const fullFieldName = buildFieldName(fieldNamePrefix, fieldName);
		const currentValue = form.getFieldValue(fullFieldName);
		const newValue = currentValue === selectedValue ? null : selectedValue;

		form.setFieldValue(fullFieldName, newValue);
	};

	return (
		<S.AdditionalFactorsContainer>
			{ADDITIONAL_FACTOR_GROUPS.map((group, groupIndex) => {
				const fieldName = buildFieldName(fieldNamePrefix, group.name);
				return (
					<React.Fragment key={group.name}>
						<FormItem name={fieldName} required={required} style={{ marginBottom: 0 }}>
							<Radio.Group style={{ width: '100%' }}>
								<Space direction="vertical" size={12} style={{ width: '100%' }}>
									{group.options.map((option) => (
										<Radio
											key={option.value}
											value={option.value}
											onClick={() => {
												const currentValue = form.getFieldValue(fieldName);
												handleRadioClick(group.name, currentValue);
											}}
										>
											<S.FactorDescriptionText>
												{I18n.get(option.labelKey)}
											</S.FactorDescriptionText>
										</Radio>
									))}
								</Space>
							</Radio.Group>
						</FormItem>
						{groupIndex < ADDITIONAL_FACTOR_GROUPS.length - 1 && <S.Divider />}
					</React.Fragment>
				);
			})}
		</S.AdditionalFactorsContainer>
	);
}
